export class NoEmailError extends Error {
	constructor(public cause: any) {
		super('No email provided');
		this.name = 'NoEmailError';
	}
}
